import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'
import { Button, Column, Row, Heading } from '../../Blocks'
import { closePopups } from '../../../utilities'

const ModalDisclaimer = () => {
  const snap = useSnapshot(state.current)
  const ribLimit = snap.initialChoices.ribLimit

  return (
    <Column>

      <Heading align="left">
        Seat size, shape, and rib count may differ from builder preview.
      </Heading>


      {ribLimit > 0 ? (
        <Heading align="left">
          Your selected model has <strong>{ribLimit}</strong> ribs.
        </Heading>)
        :
        <Heading align="left">
          This seat cover doesn't have any ribs.
        </Heading>

      }
      <Row justify="center">
        <Button fullWidth accent handleClick={closePopups}>Start Designing</Button>


      </Row>
    </Column>
  )
}

export default ModalDisclaimer

